import { useDispatch } from 'react-redux';
import { getConfigurationList, clearState } from 'actions/bomConfigurationActions';

export function useBOMConfigurationActions() {
  const dispatch = useDispatch();

  const getConfigurationListAction = () => dispatch(getConfigurationList());

  const clearStateAction = () => dispatch(clearState());

  return {
    getConfigurationListAction,
    clearStateAction
  };
}
